import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {ButtonModule} from "primeng/button";
import {FormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {InputNumberModule} from "primeng/inputnumber";
import {Ripple} from 'primeng/ripple';

import {ModelsPosition} from "../../../app/api/model/models";

@Component({
  selector: 'app-hr-position-form',
  template: `
    <p-dialog [(visible)]="visible" [style]="{width: '450px'}" header="Position Details" [modal]="true"
              styleClass="p-fluid">
      <ng-template pTemplate="content">
        <div class="field">
          <label for="name">Name</label>
          <input type="text" pInputText id="name" [(ngModel)]="position.name" required autofocus/>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="savePosition()"></button>
      </ng-template>
    </p-dialog>
  `,
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    InputNumberModule,
    Ripple
  ]
})
export class HrPositionsForm {
  @Input() visible = false;
  @Input() position: ModelsPosition = {} as ModelsPosition;
  @Output() onSave = new EventEmitter<ModelsPosition>();
  @Output() onCancel = new EventEmitter<void>();

  hideDialog() {
    this.onCancel.emit();
  }

  savePosition() {
    this.onSave.emit(this.position);
  }
}
